import { check_types,brand, brand_url,view_route, results_path } from "data/Spec";
import ChartCardGoogle from "./ChartCardGoogle"

import {React} from "react";
import useAxios from "axios-hooks";
import { NavLink } from "react-router-dom";

import Nav from "react-bootstrap/Nav";
import Spinner from 'react-bootstrap/Spinner';
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { LinkContainer } from "react-router-bootstrap";
import { FormattedMessage } from "react-intl";
import NavDropdown from "react-bootstrap/NavDropdown";


function ChartBox(props) {
  const [{ data, loading, error }] = useAxios({
    url: results_path + "/aggr.json"
  });

  if (loading || !data) {
    return (
      <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }
  if (error != null) {
    return <div>Error:{JSON.stringify(error, null, 2)}</div>;
  }
  var check_type_links = []
  Object.keys(check_types).forEach(k=> {
    let path = "/chart/" + props.ltype + "/" + k
    check_type_links.push(
      <div key={k}>
        <LinkContainer to={path}>
          <NavDropdown.Item>
          {check_types[k].title}
          </NavDropdown.Item>
        </LinkContainer>
      </div>
    )
  })
  var viewMenu = [];
  for (let key in view_route) {
    var path = "/chart/" + key;
    viewMenu.push(
      <div key={key}>
        <LinkContainer to={path}>
          <NavDropdown.Item>
            <FormattedMessage id={view_route[key]["title_id"]} />
          </NavDropdown.Item>
        </LinkContainer>
      </div>
    );
  }

  return (
    <div>
      <header className="App-header">
        <h1>{props.title} - {check_types[props.check_type].title}</h1>
      </header>
      <Navbar bg="dark" variant="dark">
      <Container>
        <Navbar.Brand href={brand_url}>{brand}</Navbar.Brand>
        <Nav className="me-auto my-2 my-lg-0">
            <NavLink to="/" className="nav-link">TOP</NavLink>
            <Navbar.Collapse id="basic-navbar-nav">
              <NavDropdown title="List" id="navbarScrollingDropdown">
                {viewMenu}
              </NavDropdown>
              <NavDropdown title="Type" id="navbarScrollingDropdown">
                {check_type_links}
              </NavDropdown>
            </Navbar.Collapse>
          </Nav>
        </Container>
      </Navbar>
      <div>
        <ChartCardGoogle data={data} title={props.title} ltype={props.ltype} check_type={props.check_type}/>
      </div>
    </div>
  );

}

export default ChartBox;
